import { ChangeDetectionStrategy, Component } from '@angular/core';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-users',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss'],
    standalone: false
})
export class UsersComponent {
  readonly FlatModels = FlatModels;

  constructor(public userSharedFacade: FlatFacades.UserSharedFacade,
              public navigationControlFacade: FlatFacades.NavigationControlFacade) {
  }

  rowTrackBy(index: number,
             item: FlatModels.UserEntityModels.User) {
    return item.id || index;
  }

  onRowSelect($event: any) {
    this.navigationControlFacade.requestNavigate(['user', $event.data]);
  }

  addNewUser() {
    this.navigationControlFacade.requestNavigate(['user']);
  }
}
